class KonamiCodeClass {
  constructor() {
    this.code = [];
    this.positionKey = 0;
    this.execudeOnSuccess = () => null;
  }

  nextKey(key) {
    if (this.code[this.positionKey] === key) {
      this.positionKey += 1;
    } else {
      this.positionKey = 0;
    }
    if (this.positionKey === this.code.length) {
      this.execudeOnSuccess();
      this.positionKey = 0;
    }
  }

  setExecudeOnSuccess(fun) {
    this.execudeOnSuccess = () => fun();
  }

  setCode(code) {
    this.code = code;
  }
}

const KonamiCode = new KonamiCodeClass();
export default KonamiCode;
